import { Component, Prop, Event, EventEmitter, h, Host } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'lar-onoff-content',
  styleUrl: 'onoff-content.scss',
  shadow: true
})
export class OnOffContent {
   @Prop() color?: Color;
   @Prop() disabled?: boolean;
   @Prop() value: string;
   @Event() buttonclick!: EventEmitter;

   onClick(event: MouseEvent) {
    this.buttonclick.emit();
    event.preventDefault();
    event.stopPropagation();
   }

   render() {
    const isOn = this.value === 'onoff.on' || this.value === 'onoff.switchoff';
    return (
      <Host>
        <div class="onoff-container">
          <lar-toggle
            disabled={this.disabled}
            color={this.color}
            checked={isOn}
            onClick={e => this.onClick(e)}
          />
        </div>
      </Host>
    );
  }
}